import { ArrowLeft, FlaskConical } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";

export function FeatureUnavailable() {
  const navigate = useNavigate();
  return (
    <div role="status" className="mx-auto mt-16 flex max-w-md flex-col items-center gap-4 text-center">
      <FlaskConical aria-hidden className="size-10 text-muted-foreground" />
      <p className="text-base">This feature isn't available in this version of ATS yet.</p>
      <Button variant="outline" onClick={() => navigate(-1)}>
        <ArrowLeft aria-hidden /> Back
      </Button>
    </div>
  );
}
